import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_INVOICES_HISTORY_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetInvoiceHistoryPayload, GetInvoiceHistoryResult, HistoryBill } from '../types/getHistoryBills.types';

export const INVOICE_HISTORY = 'InvoiceHistory';

export const getInvoiceHistory = (builder: BuilderType) =>
  builder.query<HistoryBill[], GetInvoiceHistoryPayload>({
    keepUnusedDataFor: 0,
    providesTags: [INVOICE_HISTORY],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_INVOICES_HISTORY_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetInvoiceHistoryResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.PaidBills;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
